import { ACTION_TYPES } from './drawerOrderSearch.constant';

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});

export const open = (payload) => ({
  type: ACTION_TYPES.OPEN,
  payload,
});

export const close = () => ({
  type: ACTION_TYPES.CLOSE,
});
